import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
// Initialize Firebase SOLO en web (evita cargar Google API en móviles)
// En móviles, Firebase se inicializa nativamente en AppDelegate/Application
import { Capacitor } from '@capacitor/core';
if (!Capacitor.isNativePlatform()) {
  import('./config/firebase');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);